import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  loginDetails: {},
  isLoading: false,
  error: "",
  hasData: false,
  codeStatus: "pending",
  expireTime: "",
  accesstoken: "",
  tokenExpireTime: "",
  getClearCookies: {
    data: null,
    isLoading: false,
    errors: "",
    status: ""
  }
};
const tokenExpiredSlice = createSlice({
  name: "tokenExpired",
  initialState,
  reducers: {
    getTokenExpiredDataPending: state => {
      state.isLoading = true;
      state.codeStatus = "pending";
      state.expireTime = true;
      state.tokenExpireTime = true;
      state.sessionExp = false;
    },
    getTokenExpiredDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.loginDetails = action.payload;
      state.codeStatus = "success";
      localStorage.setItem("expireTime", action.payload.tokenexpiry);
      localStorage.setItem("accesstoken", action.payload.authorization);
      window.dispatchEvent(new Event("tokenUpdated"));
      sessionStorage.setItem("tokenExpireTime", action.payload.tokenExpireTime);
    },
    getTokenExpiredDataFailure: (state, action) => {
      state.isLoading = false;
      state.codeStatus = "failure";
      state.error = action.payload;
    },
    // get Clear Cookies
    getClearCookiesRequest: state => {
      state.getClearCookies.isLoading = true;
      state.getClearCookies.errors = "";
    },
    getClearCookiesSuccess: (state, _ref) => {
      let {
        payload: user
      } = _ref;
      state.getClearCookies.isLoading = false;
      state.getClearCookies.data = user;
      state.getClearCookies.status = "success";
    },
    getClearCookiesFailure: (state, _ref2) => {
      let {
        payload: error
      } = _ref2;
      state.getClearCookies.isLoading = false;
      state.getClearCookies.errors = error;
      state.getClearCookies.status = "failure";
    },
    resetLoginData: state => {
      state.codeStatus = "pending";
      state.error = "";
      state.loginDetails = {};
      state.hasData = false;
    }
  }
});
export const {
  getTokenExpiredDataPending,
  getTokenExpiredDataSuccess,
  getTokenExpiredDataFailure,
  getClearCookiesRequest,
  getClearCookiesSuccess,
  getClearCookiesFailure,
  resetLoginData
} = tokenExpiredSlice.actions;
export default tokenExpiredSlice.reducer;